import React, { useEffect, useState } from "react";
import { Modal, Button, Tag, Row, Col, Card, Typography, Divider } from "antd";
import {
  GlobalOutlined,
  FileTextOutlined,
  TeamOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import aictia from "../../../const/api";
import moment from "moment";

const { Title, Text } = Typography;

const RegistryDetailModal = ({ open, id, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    history.goBack();
  };
  useEffect(() => {
    if (id && open) {
      getRegisterDetail();
    }
  }, [id, open]);

  const getRegisterDetail = () => {
    setLoading(true);

    aictia
      .get(`ReyestrOfCompany/details/${id}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const hasNote =
    data?.note &&
    data.note !== "<p><br></p>" &&
    data.note !== "<p>&nbsp;</p>";

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      bodyStyle={{
        padding: 0,
        borderRadius: 20,
        maxHeight: "85vh",
        overflowY: "auto",
      }}
    >
      <Title level={4} style={{ padding: 10 }}>
        🏢 Reyestr Qeydinin Detalları
      </Title>
      <hr />
      {/* Header */}
      <div
        style={{
          margin: "10px 0px 20px",
          padding: "10px 20px",
          background: "#f8fafc",
          border: "1px solid #c0c0c0",
          borderRadius: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div>
          <Text style={{ fontSize: 11, color: "#888" }}>
            {t('nameOfEntity')}
          </Text>
          <br />
          <Text strong style={{ fontSize: 18 }}>
            {data?.nameOfCompany}
          </Text>
        </div>

        <Tag color={data?.activityStatus ? "success" : "red"}>
          {data?.activityStatus ? "Aktiv" : "Bağlanıb"}
        </Tag>
      </div>

      {/* Reyestr */}
      <h3>📝 Reyestr və Hüquqi Məlumatlar</h3>
      <hr />

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('tin')}</Text>
            <br />
            <Text strong>{data?.tin || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('businessEntity')}</Text>
            <br />
            <Text strong>{data?.typeOfCompany?.name || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('registrationDate')}</Text>
            <br />
            <Text strong>
              {data?.dateOfIncorporationCompany
                ? moment(data.dateOfIncorporationCompany).format("DD.MM.YYYY")
                : "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('country')}</Text>
            <br />
            <Text strong>{data?.country?.name || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('statePrivate')}</Text>
            <br />
            <Text strong>{data?.stateorPrivate?.name || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('membershipPackage')}</Text>
            <br />
            <Text strong>
              {data?.packetOfAictiaCompanyDto
                ?.map((item) => item.name)
                .join(", ") || "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('charterCapital')}</Text>
            <br />
            <Text strong>
              {data?.authorizedCapital
                ? `${data.authorizedCapital} AZN`
                : "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('trademark')}</Text>
            <br />
            <Text strong>{data?.saleSign || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('Təqdimatın adı')}</Text>
            <br />
            <Text strong>{data?.recognizedCejjo || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('legalAddress')}</Text>
            <br />
            <Text strong>{data?.legalAddress || "-"}</Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('actualAddress')}</Text>
            <br />
            <Text strong>{data?.actualAddress || "-"}</Text>
          </div>
        </Col>


      </Row>
      {/* Fəaliyyət və Resurslar */}
      <h3>🚀 Fəaliyyət və Resurslar</h3>
      <hr />

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('typeOfActivity')}</Text>
            <br />
            <Text strong>
              {data?.typeOfActivityCompanyDto
                ?.filter((item) => item.isMain)
                ?.map((item) => item.name)
                ?.join(", ") || "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('Əlavə fəaliyyət növü')}</Text>
            <br />
            <Text strong>
              {data?.typeOfActivityCompanyDto
                ?.filter((item) => !item.isMain)
                ?.map((item) => item.name)
                ?.join(", ") || "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('fieldOfActivity')}</Text>
            <br />
            <Text strong>
              {data?.activityCompanyDto
                ?.filter((item) => item.isMain)
                ?.map((item) => item.name)
                ?.join(", ") || "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('Əlavə fəaliyyət sahəsi')}</Text>
            <br />
            <Text strong>
              {data?.activityCompanyDto
                ?.filter((item) => !item.isMain)
                ?.map((item) => item.name)
                ?.join(", ") || "-"}
            </Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t('employeeCount')}</Text>
            <br />
            <Text strong>{data?.workerCount || "-"}</Text>
          </div>
        </Col>

      </Row>

      {/* Əlaqə və Təmsilçilik */}
      <h3>📞 Əlaqə və Təmsilçilik</h3>
      <hr />

      <Row gutter={[16, 16]}>
        {/* 1-ci sütun - Şirkət */}
        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t("companyPhone")}</Text>
            <br />
            <Text strong>
              {data?.phoneOfCompany?.length
                ? data.phoneOfCompany.map((x) => x.value).join(", ")
                : "-"}
            </Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("companyEmail")}</Text>
            <br />
            <Text strong>
              {data?.officialMail?.length
                ? data.officialMail.map((x) => x.value).join(", ")
                : "-"}
            </Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("officialWebsite")}</Text>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {data?.officialWebSite ? (
                <a
                  href={`https://${data.officialWebSite}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1677ff", textDecoration: "underline" }}
                >
                  {data.officialWebSite}
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
        </Col>

        {/* 2-ci sütun - Rəsmi nümayəndə */}
        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t("officialRepresentative")}</Text>
            <br />
            <Text strong>{data?.officialCEOoftheCompany || "-"}</Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("officialRepresentativePhone")}</Text>
            <br />
            <Text strong>
              {data?.phoneOfCeo?.length
                ? data.phoneOfCeo.map((x) => x.value).join(", ")
                : "-"}
            </Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("officialRepresentativeEmail")}</Text>
            <br />
            <Text strong>
              {data?.mailOfCeo?.length
                ? data.mailOfCeo.map((x) => x.value).join(", ")
                : "-"}
            </Text>
          </div>
        </Col>

        {/* 3-cü sütun - Tanınmış rəhbər */}
        <Col span={8}>
          <div className="detail-box">
            <Text type="secondary">{t("recognizedLeader")}</Text>
            <br />
            <Text strong>{data?.recognizedCeo || "-"}</Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("directorPhone")}</Text>
            <br />
            <Text strong>{data?.phoneOrrfCeo || "-"}</Text>
          </div>

          <div className="detail-box" style={{ marginTop: 16 }}>
            <Text type="secondary">{t("personEmail")}</Text>
            <br />
            <Text strong>{data?.mailOrrfCeo || "-"}</Text>
          </div>
        </Col>
      </Row>

      {/* Əlaqəli şəxs */}
      {/* <Col span={12}>
    <div className="detail-box">
      <Text type="secondary">{t('Əlaqəli şəxs')}</Text>
      <br />
      <Text strong>{data?.officialCEOoftheCompffany || "-"}</Text>
    </div>
  </Col> */}

      {/* Əlaqəli şəxsin maili */}
      {/* <Col span={12}>
    <div className="detail-box">
      <Text type="secondary">Əlaqəli şəxsin e-maili</Text>
      <br />
      <Text strong>{data?.mailOfffCeo || "-"}</Text>
    </div>
  </Col> */}

      {/* Əlaqəli şəxsin telefonu */}
      {/* <Col span={12}>
    <div className="detail-box">
      <Text type="secondary">Əlaqəli şəxsin telefonu</Text>
      <br />
      <Text strong>{data?.phoneOfffCeo || "-"}</Text>
    </div>
  </Col> */}


      {/* Sosial Şəbəkələr */}
      {(data?.socialNetworkofCompany?.length !== 0 || data?.socialNetworkofCeo?.length !==0) && ( <>
      <h3>🌐 Sosial Şəbəkələr</h3>
      <hr />

   <Row gutter={[16, 16]}>
  {/* Şirkət */}
  {data?.socialNetworkofCompany?.length !== 0 && (
    <Col xs={24} md={12}>
      <Card
        title={
          <Text strong style={{ fontSize: 13 }}>
            Şirkət profili
          </Text>
        }
        bordered={false}
      >
        {data?.socialNetworkofCompany?.filter(item => item.value).length ? (
          data.socialNetworkofCompany
            .filter(item => item.value)
            .map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 10,
                }}
              >
                <Text strong style={{ flexShrink: 0 }}>
                  {item.type === "1" && "Facebook"}
                  {item.type === "2" && "Twitter"}
                  {item.type === "3" && "LinkedIn"}
                  {item.type === "4" && "Youtube"}
                  {item.type === "5" && "Wikipedia"}:
                </Text>

                <a
                  href={item.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                  }}
                >
                  {item.value}
                </a>
              </div>
            ))
        ) : (
          <Text type="secondary" style={{ fontSize: 10 }}>
            Məlumat yoxdur
          </Text>
        )}
      </Card>
    </Col>
  )}

  {/* Rəsmi nümayəndə */}
  {data?.socialNetworkofCeo?.length !== 0 && (
    <Col xs={24} md={12}>
      <Card
        title={
          <Text strong style={{ fontSize: 13 }}>
            Rəsmi nümayəndə
          </Text>
        }
        bordered={false}
      >
        {data?.socialNetworkofCeo?.filter(item => item.value).length ? (
          data.socialNetworkofCeo
            .filter(item => item.value)
            .map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 10,
                }}
              >
                <Text strong style={{ flexShrink: 0 }}>
                  {item.type === "1" && "Facebook"}
                  {item.type === "2" && "Twitter"}
                  {item.type === "3" && "LinkedIn"}
                  {item.type === "4" && "Youtube"}
                  {item.type === "5" && "Wikipedia"}:
                </Text>

                <a
                  href={item.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                  }}
                >
                  {item.value}
                </a>
              </div>
            ))
        ) : (
          <Text type="secondary" style={{ fontSize: 10 }}>
            Məlumat yoxdur
          </Text>
        )}
      </Card>
    </Col>
  )}
</Row>

      </>
      )}

      {/* Qeyd */}
      {hasNote && (
        <div>
          <h3 style={{ marginTop: 25 }}>📝 Qeyd</h3>
          <hr />

          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: data?.note || "<i>Qeyd yoxdur</i>",
              }}
            />
          </div>
        </div>)}
    </Modal>
  );
};

export default RegistryDetailModal;